const updateValuation = async (valuationData) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-type", "application/json");
  myHeaders.append("Authorization", localStorage.getItem("token"));

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(valuationData),
    redirect: "follow",
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/update_valuation?indeks=${valuationData.indeks}`,
    requestOptions
  )
    .then((response) => {
      return response.status;
    })
    .catch((error) => {throw new Error(error)});
};

export default updateValuation;
